import type { FC } from 'react';
import { useEffect } from 'react';

import { useFormSafe } from '../form/context';
import { showValidFields } from '../../helpers/validators/show-valid-fields';
import type { TFields } from '../form/models';

/** Подсвечивает валидные поля формы */
export const FormValidFieldHighlighter: FC = () => {
    const finalForm = useFormSafe<TFields>();

    useEffect(
        () => finalForm?.subscribe(() => showValidFields(finalForm), { modified: true }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return null;
};
